import { Container } from '@mui/material';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import React from 'react';

interface ErrorProps {
	error: string;
	primaryActionText: string;
	secondaryActionText?: string;
	primaryAction: () => void;
	secondaryAction?: () => void;
}

const Error = ({
	error,
	primaryActionText,
	secondaryActionText,
	primaryAction,
	secondaryAction,
}: ErrorProps) => {
	return (
		<Container maxWidth='sm' sx={{ pt: 8 }}>
			<Stack spacing={2} direction='column'>
				<Alert severity='error'>{error}</Alert>
				<Stack spacing={2} direction='row' justifyContent='flex-end'>
					{secondaryAction && (
						<Button onClick={secondaryAction}>{secondaryActionText}</Button>
					)}
					<Button variant='contained' onClick={primaryAction}>
						{primaryActionText}
					</Button>
				</Stack>
			</Stack>
		</Container>
	);
};

export default Error;
